module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-24.7dc21602.png";